import React from "react";
import { GitCompareArrows, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useComparison, type ComparableHome } from "@/hooks/use-comparison";
import { cn } from "@/lib/utils";

interface CompareButtonProps {
  home: ComparableHome;
  className?: string;
}

export function CompareButton({ home, className }: CompareButtonProps) {
  const { isCompared, addToComparison, removeFromComparison } = useComparison();
  const compared = isCompared(home.nh_slug);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (compared) {
      removeFromComparison(home.nh_slug);
    } else {
      addToComparison(home);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className={cn(
        "h-7 gap-1 text-xs font-medium transition-colors",
        compared
          ? "text-grandpal-green hover:text-red-500 bg-grandpal-green/10 hover:bg-red-50"
          : "text-muted-foreground hover:text-grandpal-green hover:bg-grandpal-green/10",
        className
      )}
      title={compared ? "Remove from comparison" : "Add to compare"}
    >
      {compared ? <X size={12} /> : <GitCompareArrows size={12} />}
      {compared ? "Remove" : "Compare"}
    </Button>
  );
}
